import { ExemptReason, IssueFragment, IssueLevel } from "generated-graphql/graphql";

type ExemptFormFields = {
  isExempt?: boolean | null;
  isExemptReason?: ExemptReason | null;
  isExemptNote?: string | null;
};

/**
 * Client-side validation issues for the exempt reason/note fields.
 *
 * These are returned from the form's validator so they flow through the same
 * validator -> issue -> setError pipeline as every other field. That is what
 * keeps the red outline and message visible until the field is populated: a
 * bare form.setError gets wiped by useValidatingForm's next validation cycle,
 * whereas a validator issue is re-emitted every cycle until the value is valid.
 */
export function getExemptValidationIssues(
  data: ExemptFormFields,
  modelName: string
): IssueFragment[] {
  if (!data.isExempt) {
    return [];
  }
  if (!data.isExemptReason) {
    return [exemptIssue("isExemptReason", "Select an exemption reason", modelName)];
  }
  if (data.isExemptReason === ExemptReason.Other && !data.isExemptNote?.trim()) {
    return [
      exemptIssue(
        "isExemptNote",
        "A description is required when the exemption reason is Other.",
        modelName
      ),
    ];
  }
  return [];
}

function exemptIssue(key: string, message: string, modelName: string): IssueFragment {
  return {
    __typename: "Issue",
    level: IssueLevel.Error,
    message,
    key,
    modelName,
    modelId: null,
  };
}
